/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-this-in-sfc */
import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { selectReport } from '../../../redux/selectors'

const getLoadingText = (title) => `Loading data for${title === 'Today'
  ? ' '
  : ' the '}${title.toLowerCase()}...`

export default function VaGraph({
  reportId, title, formatTimestampLabels,
}) {
  const reportCanvasRef = useRef(null)
  let chart = null
  const report = useSelector(selectReport(reportId))

  useEffect(() => {
    // if (this.props.drawerIsOpen != nextProps.drawerIsOpen) return
    if (chart) this.chart.destroy()
    if (!report) return
    const ctx = reportCanvasRef.current.getContext('2d')
    const lines = report?.data.lines.sort((a, b) => Date.parse(a.timestamp) - Date.parse(b.timestamp)) || []

    if (lines.length === 0) {
      ctx.font = '18px helvetica'
      ctx.textBaseline = 'middle'
      ctx.fillText(
        `No data available for${title === 'Today'
          ? ' '
          : ' the '}${title.toLowerCase()}`,
        0,
        150,
      )
      return
    }

    chart = new Chart(ctx, {
      type: 'bar',
      data: {
        // eslint-disable-next-line react/no-this-in-sfc
        labels: formatTimestampLabels(lines, reportId),
        datasets: [
          {
            label: 'Passed',
            data: lines.map((x) => x.passed),
            fill: false,
            backgroundColor: 'rgba(46,204,113,.5)',
          },
          {
            label: 'Failed',
            data: lines.map((x) => x.failed),
            fill: false,
            backgroundColor: 'rgba(204,32,72,.5)',
          },
          {
            label: 'Unavailable',
            data: lines.map((x) => x.unavailable),
            fill: false,
            backgroundColor: 'rgba(0,161,223,.5)',
          },
        ],
      },
      options: {
        title: {
          display: true,
          text: title,
          fontSize: 18,
          fontFamily: 'helvetica',
          fontStyle: 'normal',
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true }],
        },
      },
    })
  }, [report])

  return (
    <div
      style={{
        position: 'relative',
        padding: '0px',
        margin: '0px 0px 50px',
        width: '100%',
      }}
    >
      {report ? null : <div>{getLoadingText(title)}</div>}
      <canvas height="300" width="800" ref={reportCanvasRef} />
    </div>
  )
}

VaGraph.propTypes = {
  reportId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  formatTimestampLabels: PropTypes.func.isRequired,
}
